import { AfterContentInit, Component, ContentChildren, DestroyRef, inject, QueryList } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { NovatiqTabComponent } from '../tabs/novatiq-tab.component';

@Component({
  selector: 'novatiq-tabs-container',
  templateUrl: './novatiq-tabs.component.html',
  imports: [TranslateModule]
})
export class NovatiqTabsComponent implements AfterContentInit {
  @ContentChildren(NovatiqTabComponent) tabs: QueryList<NovatiqTabComponent>;

  private readonly destroyRef = inject(DestroyRef);

  ngAfterContentInit() {
    this.ensureActiveTab();
    this.tabs.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.ensureActiveTab());
  }

  selectTab(tab: NovatiqTabComponent) {
    this.tabs.toArray().forEach((tabvalue) => (tabvalue.active = false));
    if (tab) {
      tab.active = true;
    }
  }

  private ensureActiveTab(): void {
    const activeTabs = this.tabs.filter((tab) => tab.active);
    if (activeTabs.length === 0 && this.tabs.first) {
      this.selectTab(this.tabs.first);
    }
  }
}
